import { primaryColor, whiteColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const departmentsSubpageStyle = (theme) => ({
	dialogBody: {
		maxWidth: '288px',
		margin: '0 auto',
		paddingTop: '10px',
		[theme.breakpoints.down('xs')]: {
			width: '80%',
			paddingTop: '5px',
		},
	},
	colorsCaption: {
		marginTop: '15px',
	},
	managersCaption: {
		marginTop: '32px',
		marginBottom: '8px',
	},
	manager: {
		padding: 8,
		backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, .5)`,
		display: 'inline-flex',
		alignItems: 'center',
		borderRadius: '16px',
		marginBottom: '8px',
		marginRight: '2px',
		cursor: 'pointer',
		userSelect: 'none',
		'& > div': {
			marginRight: '2px',
		},
	},
	selectedManager: {
		backgroundColor: primaryColor[0],
		'& p': {
			color: whiteColor,
		},
	},
	managers: {
		height: '140px',
		overflowY: 'auto',
		marginTop: '16px',
	},
	icon: {
		width: '16px',
		height: 'auto',
		maxHeight: '16px',
	},
	doneIcon: {
		color: whiteColor,
	},
	addIcon: {
		color: primaryColor[0],
	},
	icons: {
		display: 'flex',
		justifyContent: 'center',
		'& > div': {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			margin: '0 11px',
			'& p': {
				marginBottom: 0,
				marginTop: '8px',
			},
			'& > div': {
				marginTop: '0!important',
				marginRight: '0!important',
				color: whiteColor,
			},
		},
	},
	noDepartmentsBody: {
		marginBottom: '60px',
		marginTop: '150px',
		[theme.breakpoints.down('xs')]: {
			marginTop: '40px',
		},
	},
	createDepartmentsBody: {
		marginTop: '27px',
		marginBottom: '48px',
	},
	blueBox: {
		padding: '16px 14px',
		backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, .06)`,
		borderRadius: '8px',
		marginTop: '16px',
		position: 'relative',
		'& p': {
			marginBottom: 0,
		},
	},
	arrow: {
		position: 'absolute',
		borderTopWidth: 0,
		borderBottom: `10px solid rgba(${hexToRgb(primaryColor[0])}, .06)`,
		borderLeft: '5px solid transparent',
		borderRight: '5px solid transparent',
		left: '30px',
		top: '-10px',
	},
	noDepartments: {
		display: 'flex',
		alignContent: 'center',
		flexDirection: 'column',
		textAlign: 'center',
	},
	noDepartmentsManagerView: {
		'& p': {
			marginBottom: '10px',
			'&:last-of-type': {
				marginBottom: 0,
				marginTop: 0,
			},
		},
	},
});

export default departmentsSubpageStyle;
